import { type I18nTextType } from "./types";

export const monthsNames: Record<string, I18nTextType> = {
  1: {
    ru: "Январь",
    en: "January",
  },
  2: {
    ru: "Февраль",
    en: "February",
  },
  3: {
    ru: "Март",
    en: "March",
  },
  4: {
    ru: "Апрель",
    en: "April",
  },
  5: {
    ru: "Май",
    en: "May",
  },
  6: {
    ru: "Июнь",
    en: "June",
  },
  7: {
    ru: "Июль",
    en: "July",
  },
  8: {
    ru: "Август",
    en: "August",
  },
  9: {
    ru: "Сентябрь",
    en: "September",
  },
  10: {
    ru: "Октябрь",
    en: "October",
  },
  11: {
    ru: "Ноябрь",
    en: "November",
  },
  12: {
    ru: "Декабрь",
    en: "December",
  },
};

export const weeksNames: Record<string, I18nTextType> = {
  0: { ru: "пн", en: "Mo" },
  1: { ru: "вт", en: "Tu" },
  2: { ru: "ср", en: "We" },
  3: { ru: "чт", en: "Th" },
  4: { ru: "пт", en: "Fr" },
  5: { ru: "сб", en: "Sa" },
  6: { ru: "вс", en: "Su" },
};

export type Locale = "ru" | "en";
